import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export abstract class AbstractSpinControl extends AbstractControl {

    protected button: FlexiButton;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.button = layer.getFlexiButton(assetName);
        this.button.on(ButtonEvent.CLICK, () => this.onButtonPressed());
    }

    public destroy() {
        if (this.button) {
            this.button.destroy();
            this.button = null;
        }

        super.destroy();
    }

    public setEnabled(enabled: boolean): void {
        this.button.setEnabled(enabled);

        super.setEnabled(enabled);
    }

    protected onButtonPressed() {
        //
    }
}
